import React, { useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
} from "@material-ui/core";

import ModalDialog from "../ModalDialog";

import TextField from "../../../../../../Component/Forms/TextField";
import { useTranslation } from "react-i18next";

const RiskInfo = (props) => {
  const { classes, countryRiskData, canEdit } = props;
  const { t } = useTranslation();

  const { riscScores = [], riscScoresData = [] } = countryRiskData || {};

  const [open, setOpen] = useState(false);
  const [editFields, setEditFields] = useState([]);

  return (
    <div>
      <Grid container spacing={2}>
        {riscScores.map((val) => {
          const score_data = riscScoresData.filter(
            (x) => x.section === val.section
          );

          return (
            <Grid item xs={4} key={val.section}>
              <Card elevation={0} className={classes.riskCard}>
                <CardContent>
                  <Grid container>
                    <Grid item xs={12} className={classes.riskCardContent}>
                      <div style={{ width: 60, display: "flex" }}>
                        <Chip
                          size={"small"}
                          style={{ border: "1px solid #E30613" }}
                          label={val.override_rating || val.jll_rating || "NA"}
                        />
                      </div>
                      <Typography>{t(`labels.country.countryRiskData.sections.${val.section}`)}</Typography>
                      <div className={classes.riskCardEditButton}>
                        {/* {canEdit && (
                          <IconButton
                            onClick={() =>
                              setOpen((open) => !open) ||
                              setEditFields(score_data)
                            }
                            size={"small"}
                          >
                            <EditIcon />
                          </IconButton>
                        )} */}
                      </div>
                    </Grid>
                    <Grid item xs={12} className={classes.riskCardContentScore}>
                      {score_data &&
                        score_data.map((item) => {
                          return (
                            <div key={item.data_name}>
                              <Typography>{item.data_name}</Typography>
                              <Typography>
                                {item.numeric_value || "NA"}
                              </Typography>
                            </div>
                          );
                        })}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          );
        })}

        {!riscScores && (
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Typography>{t("messages.country.noDataForCountry")}</Typography>
          </div>
        )}
      </Grid>
      <ModalDialog
        open={open}
        onClose={() => setOpen(false)}
        title={t("labels.country.countryRiskData.editCountryRiskData")}
      >
        <Grid container>
          {editFields &&
            editFields.map((val) => {
              return (
                <Grid item xs={4} key={val.data_name} style={{ minWidth: 300 }}>
                  <TextField
                    label={val.data_name}
                    initialValue={val.numeric_value || 0}
                  />
                </Grid>
              );
            })}
          <Grid item xs={4} style={{ minWidth: 300 }}>
            <TextField label={t("labels.country.countryRiskData.score")} />
          </Grid>
        </Grid>
      </ModalDialog>
    </div>
  );
};

export default RiskInfo;
